import { getCustomer } from "@/graphql/schemas/shared/utils/getCustomer"
import { EinzaGraphiQLService } from "@/services/einzaGraphiQL"
import { AppSettings } from "@/settings"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

export const queryFindPrevNextOrderForCustomer = {
  async findPrevNextOrderForCustomer(_parent, args, context, _info) {
    const { customerNumber, currentOrderNumber, orderType, cdn, lang, filters } = args
    const config = AppSettings.sanityConfigByLang(lang)

    const hasAddressFilter = (filter) => filter.field.includes("address")
    let filterValues = filters.filter((item) => !hasAddressFilter(item))

    if (filters?.some(hasAddressFilter)) {
      const customer = await getCustomer({
        number: customerNumber,
      })

      // remove the address filter again as it is not working on the graphql query
      const addressFilter = filters.filter((item) => hasAddressFilter(item))

      if (customer?.addresses?.length > 0) {
        const customerAddresses = customer.addresses || []
        const shippingAddressIds = customer?.shippingAddressIds || []

        // filtered shipping addresses
        let shippingAddresses = customerAddresses.filter((address) => shippingAddressIds.includes(address.id))

        shippingAddresses = shippingAddresses.filter((address) => address.id === addressFilter[0].value)

        if (shippingAddresses.length > 0) {
          const addressFilters = [
            shippingAddresses[0].postalCode && {
              field: "shippingPostalCode",
              operator: "eq",
              value: shippingAddresses[0].postalCode,
            },
            shippingAddresses[0].streetName && {
              field: "shippingStreet",
              operator: "eq",
              value: shippingAddresses[0].streetName,
            },
            shippingAddresses[0].city && {
              field: "shippingCity",
              operator: "eq",
              value: shippingAddresses[0].city,
            },
          ].filter((filter) => filter)

          filterValues = filterValues.concat(addressFilters)
        }
      }
    }

    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.ORDERS,
      operation: Operations.READ,
    })

    const variables =
      filterValues && filterValues.length > 0
        ? { customerNumber, currentOrderNumber, filters: filterValues }
        : { customerNumber, currentOrderNumber, orderType }

    const graphiQLQueryObject = [
      {
        method:
          filterValues && filterValues.length > 0
            ? "result: findPrevNextOrderForCustomerAndFilter"
            : "result: findPrevNextOrderForCustomer",
        variables: variables,
        fields: ["previousOrderNumber", "nextOrderNumber"],
      },
    ]

    const mappedQuery = EinzaGraphiQLService.formQuery(graphiQLQueryObject)
    const customerOrderResponse = (await EinzaGraphiQLService.getData(mappedQuery))?.data?.result

    if (!customerOrderResponse) throw new Error("Customer prev and next order not found")

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: customerNumber,
    })

    return {
      previousOrderNumber: customerOrderResponse.previousOrderNumber,
      nextOrderNumber: customerOrderResponse.nextOrderNumber,
    }
  },
}
